import { memo } from "react";

import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/input/select";

type Props = {
	yearOrMonth: string;
	onSet: (input: string) => void;
	options: string[];
	suffix: "年" | "月";
};

export const YearOrMonthSelectBox = memo(({ yearOrMonth, onSet, options, suffix }: Props) => {
	return (
		<div className="flex items-center gap-x-2">
			<Select onValueChange={onSet} defaultValue={yearOrMonth}>
				<SelectTrigger className="w-24">{yearOrMonth}</SelectTrigger>
				<SelectContent>
					{options.map((item) => (
						<SelectItem key={`year-or-month-${item}-${suffix}`} value={item}>
							{item}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			<p>{suffix}</p>
		</div>
	);
});
